module.exports = __webpack_public_path__ + "img/bt2.a6d05e7a.png";